module.exports = {"searchSection":{"title":"Search Guest List","searchInputPlaceholder":"First name, last name, phone no. …","clearButton":"Clear"},"resultSection":{"title":"My Guest List","table":{"firstnameCol":"First name","lastnameCol":"Last name","phoneCol":"Phone no.","removeFromAction":""}},"meta":"Guestlist"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/guestlist.json
// module id = hGhu
// module chunks = 1